
function shuffle(arrays) {
  const array = arrays.slice()
  for (let i = array.length - 1; i >= 0; i--) { //array.length - 1 配列の最後の要素のインデックス 0から始まるから -1

    const randomIndex = Math.floor(Math.random() * (i + 1));
    [array [i], array[randomIndex]] = [array[randomIndex], array[i]]
  }
  return array
}

function getRandomNumber(min, max, isInteger = false) {
  const randomValue = Math.random() * (max - min) + min;
  return isInteger ? Math.floor(randomValue) : randomValue;
}


const sweetsList = document.getElementById('sweetsList')
if (!sweetsList) return;

const sweetsItems = Array.from(sweetsList.children);

const shuffledItems = shuffle(sweetsItems); //slice(0, 1)
//console.log(shuffledItems) //shuffledItemsには、li要素 個が入っている
// 表示するアイテム数と列数の計算
let minNumber = 7
let maxNumber = 11
let columnGap = 3 // %
let translateValue = 10

if (window.innerWidth < 600) {
  minNumber = 4
  maxNumber = 4
  columnGap = 1
  translateValue = 15
  // モバイル用のスタイル調整
} else if (window.innerWidth < 1000) {
  minNumber = 5
  maxNumber = 7
  columnGap = 1.5
}
const showNumber = getRandomNumber(minNumber,maxNumber,true)
// console.log(showNumber);

// PC用のスタイル調整
if (showNumber <= 3) {
  columnGap = 0;
  sweetsList.classList.add('is-small--3');
  // console.log('3以下個です')
} else if (showNumber === 4 || showNumber === 5 || showNumber === 6) {
  columnGap = 0;
  sweetsList.classList.add(`is-small--${showNumber}`);
  // console.log(showNumber + '個です')
}

const columnNumber = Math.ceil(showNumber / 2)

if (sweetsList) {
  sweetsList.style.columnGap = columnGap + '%';
}

// リストを空にしてシャッフルした要素を再挿入
sweetsList.innerHTML = '';

for ( let i = 0; i < showNumber; i++) {
  const item = shuffledItems[i];

  if (!item) {
    // console.warn('item is undefined, skipping');
    continue; // itemが存在しない場合、次のループへ
  }

  const borderRadius = `${getRandomNumber(40, 45)}% ${getRandomNumber(55, 60)}% ${getRandomNumber(40, 45)}% ${getRandomNumber(55, 60)}% / ${getRandomNumber(35, 50)}% ${getRandomNumber(50, 65)}% ${getRandomNumber(35, 50)}% ${getRandomNumber(50, 65)}%`;
  const animationDelay = getRandomNumber(0, 2) + 's';
  const baseTransformlateX = `translateX(${getRandomNumber(-translateValue, translateValue)}%)`;
  const baseTransformlateY = `translateY(${getRandomNumber(-translateValue, translateValue)}%)`;
  const baseTransformScale = `scale(${getRandomNumber(.6, .9)})`;
  
  item.style.width = `${(100 - (columnNumber - 1) * columnGap) / columnNumber}%`;
  if (window.innerWidth < 600 && showNumber <= 3) {
    // 600px以下で表示数が3個以下の場合
    item.style.width = '100%';
  } else if (window.innerWidth < 600 && showNumber === 4) {
    // 600px以下で表示数が4個の場合は100%にしない
    item.style.width = `${(100 - (columnNumber - 1) * columnGap) / columnNumber}%`;
  } else if (window.innerWidth < 1000 && showNumber <= 4) {
    // 600pxから1000px未満で表示数が4個以下の場合
    item.style.width = '100%';
  } else if (window.innerWidth >= 1000 && showNumber <= 6) {
    // 1000px以上で表示数が6個以下の場合
    item.style.width = '100%';
  }
  
  item.style.transform = `${baseTransformlateX} ${baseTransformlateY} ${baseTransformScale}`;
  item.style.borderRadius = borderRadius;
  item.style.animationDelay = animationDelay;
  
  const link = item.querySelector('a');
  link.style.borderRadius = borderRadius;

    
    sweetsList.appendChild(item);
    sweetsList.insertAdjacentHTML('beforeend', `
      <style>
          li::before, li::after {
            border-radius: ${borderRadius};
          }
      </style>
    `);
    

    sweetsList.querySelectorAll('li').forEach((li) => {
      li.classList.add('is-visible');
      li.addEventListener('animationend', (event) => {
        if (event.animationName === 'fadeIn') {
        li.classList.add('float-animation');
        }
      });
    });


  
}







